<template>
  <div class="main-container">
    <router-view></router-view>

    <Header />

    <br />
    <br />
    <br />
    <br />

    <slot></slot>
    <FooterMain />
  </div>
</template>

<script>
import Header from "../components/HeaderElement";
import FooterMain from "../components/FooterMain";

export default {
  name: "PageHousing",
  components: {
    Header,
    FooterMain,
  },
};
</script>
